import React from 'react';
import { ExpertiseCalendarCard } from '../ExpertiseCalendarCard';
import { DayCellProps } from '../../types/planning.types';
import './DayCell.styles.css';

export const DayCell: React.FC<DayCellProps> = ({
  date,
  expertises,
  isToday,
  isPast,
  onExpertiseClick
}) => {
  const classNames = [
    'calendar-cell',
    isToday && 'calendar-cell--today',
    isPast && 'calendar-cell--past'
  ].filter(Boolean).join(' ');

  return (
    <div className={classNames}>
      {expertises.length === 0 ? (
        <div className="calendar-cell__empty">
          <span>Aucune visite</span>
        </div>
      ) : (
        <div className="calendar-cell__expertises">
          {expertises.map(expertise => (
            <ExpertiseCalendarCard
              key={expertise.id}
              expertise={expertise}
              onDetailClick={() => onExpertiseClick?.(expertise)}
              onFMClick={() => {
                // TODO: Open in FileMaker
                console.log('Open in FileMaker:', expertise.id);
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
};